import { BOUGHT_CHART_INTL_KEY, CONTRACTED_VOLUME, MONTHLY_VOLUME_BOUGHT, QUARTERLY_VOLUME_BOUGHT, YEARLY_VOLUME_BOUGHT } from './contants';
import {
  GRAPH_BUYING_COLOR,
  GRAPH_MONTH_PRODUCT_COLOR,
  GRAPH_QUARTER_PRODUCT_COLOR,
  GRAPH_VOLUME_COLOR,
  GRAPH_YEAR_PRODUCT_COLOR,
} from '../../constants/colors';
import { BUYING_VOLUME_PRODUCT_TYPE, volumeBigToNumber } from '../../utils/volumes';
import { INTL_VOLUME_FORMAT } from '../../App';

export const getDataSeriesConfig = (intl) => {
  return {
    [CONTRACTED_VOLUME]: {
      name: intl.formatMessage({
        id: `${BOUGHT_CHART_INTL_KEY}.contracted_volume_name`,
        defaultMessage: 'Contracted volume',
      }),
      color: GRAPH_VOLUME_COLOR,
    },
    [MONTHLY_VOLUME_BOUGHT]: {
      name: intl.formatMessage({
        id: `${BOUGHT_CHART_INTL_KEY}.monthly_volume_name`,
        defaultMessage: 'Month product',
      }),
      color: GRAPH_MONTH_PRODUCT_COLOR,
    },
    [QUARTERLY_VOLUME_BOUGHT]: {
      name: intl.formatMessage({
        id: `${BOUGHT_CHART_INTL_KEY}.quarterly_volume_name`,
        defaultMessage: 'Quarter product',
      }),
      color: GRAPH_QUARTER_PRODUCT_COLOR,
    },
    [YEARLY_VOLUME_BOUGHT]: {
      name: intl.formatMessage({
        id: `${BOUGHT_CHART_INTL_KEY}.yearly_volume_name`,
        defaultMessage: 'Year product',
      }),
      color: GRAPH_YEAR_PRODUCT_COLOR,
    },
    [BUYING_VOLUME_PRODUCT_TYPE]: {
      name: intl.formatMessage({
        id: `${BOUGHT_CHART_INTL_KEY}.currently_buying`,
      }),
      color: GRAPH_BUYING_COLOR,
    },
  };
};

export const getDataSeriesConfigByKey = (dataSeriesKey, intl) => {
  return getDataSeriesConfig(intl)[dataSeriesKey];
};

export const formatChartVolumeBig = (intl, valueBig) => {
  return intl.formatNumber(volumeBigToNumber(valueBig), {
    format: INTL_VOLUME_FORMAT,
  });
};

export const EMPTY_CONTRACTED_YEAR_DATA = [
  {
    productType: CONTRACTED_VOLUME,
    quantities: [
      {
        month: 1,
        quantity: 0,
      },
      {
        month: 2,
        quantity: 0,
      },
      {
        month: 3,
        quantity: 0,
      },
      {
        month: 4,
        quantity: 0,
      },
      {
        month: 5,
        quantity: 0,
      },
      {
        month: 6,
        quantity: 0,
      },
      {
        month: 7,
        quantity: 0,
      },
      {
        month: 8,
        quantity: 0,
      },
      {
        month: 9,
        quantity: 0,
      },
      {
        month: 10,
        quantity: 0,
      },
      {
        month: 11,
        quantity: 0,
      },
      {
        month: 12,
        quantity: 0,
      },
    ],
  },
];
